import {NavLink} from 'react-router-dom';
import {RxCaretLeft} from "react-icons/rx";
import WebPaths from "@router/paths/web";

const QuickPages = ({data, title = '', type}) => {
    const quickPages = [
        {title: 'محصولات', link: WebPaths.products()},
        {title: 'مقالات', link: WebPaths.articles()},
        {title: 'راهنمای سفارش', link: WebPaths.guide},
        {title: 'قوانین و مقررات', link: WebPaths.rules},
        {title: 'محاسبه قیمت طلا', link: WebPaths.calculator},
    ];
    return (
        <>
            <div className="link-sections-section-title">
                <h4 className="link-sections-section-title-text">
                    {title}
                </h4>
            </div>

            <div className="link-sections-section-items">
                {type === 0 ? data?.map((page, index) => (
                    <NavLink
                        className="link-sections-section-items-item"
                        key={index}
                        to={WebPaths.category(page.slug)}
                    >
                        <RxCaretLeft className="d-none d-md-block"/>
                        {page.title}
                    </NavLink>
                )) : quickPages?.map((page, index) => (
                    <NavLink
                        className="link-sections-section-items-item"
                        key={index}
                        to={page.link}
                    >
                        <RxCaretLeft className="d-none d-md-block"/>
                        {page.title}
                    </NavLink>
                ))
                }
            </div>
        </>
    );
};

export default QuickPages;
